"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEventPayload = exports.checkParamType = exports.checkParamDefined = exports.serializeUser = void 0;
var RequestEvent_1 = require("./RequestEvent");
var serializeUser = function (user) {
    var convertToQueryFriendlyFormat = function (property) {
        if (property instanceof Date) {
            return property.getTime();
        }
        if (typeof property === 'object') {
            return JSON.stringify(property);
        }
        return property;
    };
    return Object.keys(user)
        .reduce(function (prev, curr, _) {
        var userProperty = convertToQueryFriendlyFormat(user[curr]);
        var nextQueryParam = userProperty !== null && userProperty !== undefined
            ? "".concat(prev && '&').concat(curr, "=").concat(encodeURIComponent(userProperty))
            : '';
        return "".concat(prev).concat(nextQueryParam);
    }, '');
};
exports.serializeUser = serializeUser;
var checkParamDefined = function (name, param) {
    if (param === undefined || param === null) {
        throw new Error("Missing parameter: ".concat(name));
    }
};
exports.checkParamDefined = checkParamDefined;
var checkParamType = function (name, param, type) {
    if (!param) {
        throw new Error("Missing parameter: ".concat(name));
    }
    if (typeof param !== type) {
        throw new Error("".concat(name, " is not of type ").concat(type));
    }
};
exports.checkParamType = checkParamType;
function generateEventPayload(config, user, events) {
    return {
        events: events.map(function (event) {
            return new RequestEvent_1.DVCRequestEvent(event, user.user_id, config.featureVariationMap);
        }),
        user: user
    };
}
exports.generateEventPayload = generateEventPayload;
exports.default = {
    serializeUser: exports.serializeUser,
    checkParamDefined: exports.checkParamDefined,
    generateEventPayload: generateEventPayload
};
//# sourceMappingURL=utils.js.map